"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hiddenMapStyles = void 0;
const hiddenMapStyles = () => ({
  left: 0,
  opacity: 0,
  position: 'absolute',
  top: 0,
  zIndex: -1
});
exports.hiddenMapStyles = hiddenMapStyles;